// export const environment = {
//   production: true,
//   basePath: 'https://mobiapi.chgsd.com/api',
//   tenant: 'T002',
//   supportedCountry: ['IN', 'UK', 'US'],
//   idleTimeEnable: true
// };

export const environment = {
  production: false,
  basePath: 'https://solaridms-demo-api.rainbow.health/api',
  tenant: 'rcdms002',
  supportedCountry: ['IN', 'US'],
  idleTimeEnable: true,
  signInVersion: '2.0.4',
  firebase: {
    apiKey: 'AIzaSyCB4VP9b2u1MPnY75IvwgMlukvb-W2AUCw',
    authDomain: 'solari-dms-lower-env.firebaseapp.com',
    projectId: 'solari-dms-lower-env',
    storageBucket: 'solari-dms-lower-env.appspot.com',
    messagingSenderId: '369345479731',
    appId: '1:369345479731:web:6756ca9a7c8b6a45854f46',
    measurementId: 'G-EF1CS8D7M6'
  }
};
